import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';
import { brandPrimary, brandSecondary, darkGrayFontColor, mention, midGrey, navigation } from '../../styles/colors';
import { CssSelectors } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	addCard: {
		alignItems: 'center',
		backgroundColor: mention,
		borderColor: brandSecondary,
		borderRadius: 5,
		borderStyle: 'dashed',
		borderWith: 1,
		color: brandPrimary,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 18,
		justifyContent: 'center',
		minHeight: 113,
		padding: '25px 21px',
		position: 'relative',
	},
	cardsContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: 30,
		minHeight: 100,
		paddingBottom: THEME.spacing.xxl,
		position: 'relative',
		...CssSelectors.allChildren({
			flexBasis: '25%',
			flexGrow: 1,
			margin: '20px 1%',
			maxWidth: '28%',
		}),
	},
	clipboardIcon: {
		height: 12,
		marginRight: 6,
		width: 12,
	},
	container: {
		padding: 20,
	},
	copyLinkButton: {
		marginTop: 8,
		maxWidth: 250,
	},
	headerContainer: {
		marginBottom: 24,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
	},

	headerLeft: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
		flex: 1,
	},

	headerRight: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		marginLeft: 16,
		gap: 8,
	},
	noMeetings: {
		color: navigation,
		textAlign: 'center',
	},
	text: {
		color: midGrey,
		fontSize: 14,
		maxWidth: 400,
	},
	userSearchContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	userSearchLabel: {
		fontSize: 14,
		color: darkGrayFontColor,
		whiteSpace: 'nowrap',
	},
	teamLinksLink: {
		color: brandPrimary,
		fontSize: 14,
		textDecoration: 'none',
		':hover': {
			textDecoration: 'underline',
		},
	},
});
